export default __webpack_public_path__ + "static/media/tea.591a2362.591a2362.svg";